import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import SurveysGridContainer from "../containers/SurveysGridContainer";
import NewSurvey from "../components/NewSurvey";
import Slider from "../components/Slider";
import surveys_api from "../api/protected/surveys";
import search from "../assets/search.png";
import add from "../assets/add.png";
import info from "../assets/info-icon.png";
import TitleDescriptionPopup from "../components/TitleDescriptionPopup";
import plus from "../assets/add.png";
import summary from "../assets/overview.svg"
import VerifyEmailPopup from "../components/VerifyEmailPopup";
import dashboard_api from "../api/protected/dashboard";


const Surveys = () => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams();
    const [surveys, setSurveys] = useState([]);
    const [userSurveys, setUserSurveys] = useState([]);
    const [demoSurveys, setDemoSurveys] = useState([]);
    const [showNewSurvey, setShowNewSurvey] = useState(false);
    const [showSurveysGrid, setShowSurveysGrid] = useState(true);

    const [showHidden, setShowHidden] = useState(false);
    const [searchTerm, setSearchTerm] = useState('')

    const [point, setPoint] = useState(1)
    const [correctPoint, setCorrectPoint] = useState(false);

    const [showTitleHover, setShowTitleHover] = useState(false)
    const titleDescription = ["Use this page to create and manage Surveys. There are three options:",
                                      "1. Use the Plus icon to create a new Survey",
                                      "2. Select from the list below to view participant responses, edit survey participants and resend survey invitations",
                                      "3. Select the (INSERT SURVEY SUMMARY ICON) to configure and generate the survey report."]
    const titlePopupStyle = {top: 35, left: 160}

    useEffect(() => {
        setSurveys([...demoSurveys, ...userSurveys])
    }, [userSurveys, demoSurveys])

    useEffect(() => {

    }, [])

    useEffect(() => {
        if (searchParams.get("new") === "1"){
            setShowNewSurvey(true)
            setShowSurveysGrid(false);
            setSearchParams({});
        };

    })

    const [showVerifyEmailPopup, setShowVerifyEmailPopup] = useState(false);
    useEffect(() => {
        dashboard_api.getValidateEmail().then((response) => {
            console.log("HERE IS THE RESPONSE: ", response)
            const isAlreadyVerified = response.data === 1;

            if (!isAlreadyVerified) {
                console.log("Need to verify")
                navigate("/verify?unverified=true")
            } else {
                setShowVerifyEmailPopup(false)
            }
        })
    }, []);

    const handleAddSurvey = () => {
        setShowNewSurvey(true);
        setShowSurveysGrid(false);
    }

    const handleEditSurvey = (survey) => {
        if(survey.demo) {
            navigate(`/surveys/${survey.id}?demo=true`);
        } else {
            navigate(`/surveys/${survey.id}`);
        }
    }

    const getSurveys = () => {
        let response = surveys_api.getSurveys();
        response.then(response => {
            setUserSurveys(response.data.surveys);
        })
        response = surveys_api.getDemoSurveys();
        response.then(response => {
            setDemoSurveys(response.data.surveys)
        })
    }

    const updateSurveysGrid = () => {
        getSurveys();
        setShowNewSurvey(false);
        setShowSurveysGrid(true);
    }

    useEffect(() => {
        if (localStorage.getItem("new_survey") !== null) {
            setPoint(localStorage.getItem("new_survey"))
            localStorage.removeItem("new_survey");
            handleAddSurvey();
        } else {
            setCorrectPoint(true)
            getSurveys()
        }
    }, [])

    const updateToggleHidden = () => {
        setShowHidden(!showHidden);
    }

    return (
        <div className="surveys-page-background-container">
            <div className="surveys-page-container">
                {showSurveysGrid ?
                    <>
                        <div className="surveys-page-header">
                            <div className="page-header-title-container">
                                <div className="surveys-page-title">Surveys</div>
                                <img src={info} alt="Info"
                                     onMouseOver={() => setShowTitleHover(true)}
                                     onMouseLeave={() => setShowTitleHover(false)}
                                />
                                {showTitleHover ?
                                    <div className="title-description-popup-container" style={titlePopupStyle}>
                                        <div className="page-title-hover-triangle-outer">
                                            <div className="page-title-hover-triangle-inner"/>
                                        </div>
                                        <div className="title-description-popup-text">
                                            Use this page to create and manage Surveys. There are three options:
                                        </div>
                                        <div className="title-description-popup-text">
                                            1. Use the <img src={plus} alt="+"/> to create a new Survey
                                        </div>
                                        <div className="title-description-popup-text">
                                            2. Select from the list below to view participant responses, edit survey
                                            participants and resend survey invitations
                                        </div>
                                        <div className="title-description-popup-text">
                                            3. Select the <img src={summary} alt="survey summary link"/> to configure and generate the survey report
                                        </div>
                                    </div>
                                    :null}
                            </div>
                            <div className="surveys-page-search-container">
                                <input type="text" placeholder="Survey Search" value={searchTerm}
                                       onChange={ev => setSearchTerm(ev.target.value)}
                                       onKeyUp={ev => {
                                           if (ev.key === 'Enter') navigate("/search?term=" + searchTerm)
                                       }}
                                />
                                <img src={search} alt="search icon" className="link"/>
                            </div>
                        </div>
                        <div className="page-actions-container">
                            <div className="page-toggle-hidden">
                                <Slider update={updateToggleHidden.bind(this)} state={showHidden}/>
                            </div>
                            <div className="toggle-hidden-text">Show hidden</div>
                            <div className="surveys-page-add-container">
                                <img src={add} alt="add icon" className="link" onClick={handleAddSurvey}/>
                            </div>
                        </div>
                        <SurveysGridContainer surveys={surveys} showHidden={showHidden}
                                              handleClick={handleEditSurvey.bind(this)}
                        />
                    </> : null
                }
                {showNewSurvey ?
                    <NewSurvey updateSurveysGrid={updateSurveysGrid} passedPoint={point}
                               setPassedPoint={setPoint.bind(this)} correctPoint={correctPoint}/>
                    : null
                }
                {showVerifyEmailPopup && showVerifyEmailPopup ?
                    <VerifyEmailPopup wide={false} /> : null }
            </div>
        </div>
    )
}

export default Surveys
